/* ===========================================================
 * Responsive Hero
 * ===========================================================
 * Devin Schulz <devin@invisionapp.com>
 * http://www.invisionapp.com
 *
 * Create responsive hero images and allow hero content to center vertically
 * properly. This plugins also factors in the navbar and logo container height.
 *
 * ========================================================== */
$.fn.responsiveHero = function (options) {
    var defaults = {
        hero: $(this), // jQuery object - The main hero selector.
        container: $('.hero-container'), // jQuery object - The inner container containing titles, subtitles, etc.
        navigationHeight: 0, // int || jQuery object - If there is a header that needs to be factored into the height.
        logoContainerHeight: 0, // int || jQuery object - A container below the hero that needs to always be in view.
        mobileMaxWidth: 767, // int - The viewport max width for mobile.
        desktopMinWidth: 992, // int - The viewport min width for desktop.
        containerOffsetTop: 0, // int - If the title needs to be pushed up or down to make it visually more centered.
        calculateOnTablet: false, // bool - Should the hero be calcuated on tablet?
        calculateOnMobile: false, // bool - Should the hero be calcuated on mobile?
        padTopOnly: false, // bool - Should padding be added to top only?
        padBottomOnly: false, // bool - Should padding be added to bottom only?
        windowDebounce: 200, // int - After the window is resized how long should I wait to trigger a re-calculate.
    };

    var settings = $.extend({}, defaults, options);

    /**
     * If a jQuery object is the setting, calculate it's height and return
     * an integer
     *
     * @param  {object} || {int} item [description]
     * @return {int}      [description]
     */

    /**
     * Calculate and set the padding around the container's content
     */
    function calculate() {
        var containerHeight = $(settings.container).height(),
            navHeight = ($.isNumeric(settings.navigationHeight)) ? settings.navigationHeight : $(settings.navigationHeight).outerHeight(true),
            logoHeight = ($.isNumeric(settings.logoContainerHeight)) ? settings.logoContainerHeight : $(settings.logoContainerHeight).outerHeight(true);

        var mobile = window.matchMedia('(max-width: ' + settings.mobileMaxWidth + 'px)'),
            tablet = window.matchMedia('(min-width: ' + (settings.mobileMaxWidth + 1) + 'px) and (max-width: ' + (settings.desktopMinWidth - 1) + 'px)'),
            desktop = window.matchMedia('(min-width: ' + settings.desktopMinWidth + 'px)');

        var $win = $(window),
            $windowOuterHeight = $win.outerHeight();

        if (desktop.matches || (tablet.matches && settings.calculateOnTablet === true) || (mobile.matches && settings.calculateOnMobile === true)) {
            // grab the height of the navigation, logos, and all content inside the container
            var remainingSpace = Math.round($windowOuterHeight - logoHeight - navHeight - containerHeight);

            if (settings.padTopOnly) {
                // pad top only
                settings.container.css({
                    paddingTop: remainingSpace + settings.containerOffsetTop
                });
            } else if (settings.padBottomOnly) {
                // pad bottom only
                settings.container.css({
                    paddingBottom: remainingSpace - settings.containerOffsetTop
                });
            } else {
                // pad both top and bottom
                remainingSpace = Math.round(remainingSpace / 2);
                settings.container.css({
                    paddingTop: remainingSpace + settings.containerOffsetTop,
                    paddingBottom: remainingSpace - settings.containerOffsetTop
                });
            }

        } else {
            if (settings.containerOffsetTop > 0) {
                settings.container.css({
                    paddingTop: settings.containerOffsetTop
                });
            } else {
                settings.container.attr('style', null);
            }
        }
    }

    /**
     * Recaculate when window has been resized
     */
    var resizeTimer;

    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(calculate, settings.windowDebounce);
    });

    calculate();
};